import configLib from '../../../configLib';
import { parsingResponseFailed } from '../../store/gateway';
import { updateTradePriceCacheFromTrade } from '../../store-util/TradePriceCache';
import { parseGatewayData } from '../../util/GatewayHelpers';
import { dataArrayToMap } from '../../util/MarketDataHelpers';
import { WebSocketEventData } from '../custom-event/types';
import { LoggerService } from '../logger/Logger.service';
import { GatewayRequestType, GatewayResponseSubType, GatewayResponseType } from '../web-socket/types';

import { BaseSymbolSubscriptionService } from './BaseSymbolSubscription.service';
import { SymbolSubscriptionRequestType } from './types';

const LOG_PREFIX = '[MDST-SUBS]';
const logger = LoggerService.getLogger();

/**
 * Market Data Subscribe Trade Subscription Service
 */
export class MDSTSubscriptionService extends BaseSymbolSubscriptionService<SymbolSubscriptionRequestType> {
  private static instance: MDSTSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): MDSTSubscriptionService {
    if (!this.instance) {
      this.instance = new MDSTSubscriptionService();
    }

    return this.instance;
  }

  // TODO: HW-1162  Cover all cases with unittesting
  public handleResponseEvent = (event: WebSocketEventData<any>): void => {
    if (event.data.messageSubType !== GatewayResponseSubType.Trade) {
      return;
    }
    const data = event.data ?? {};
    let parsedData;
    logger.log(`${LOG_PREFIX} MDSTSubscription response! data:`, event);

    try {
      parsedData = parseGatewayData(data.arrayData);
    } catch (error) {
      configLib.store.dispatch(parsingResponseFailed(`${error}`));// TODO:Remove this and all action call from service(s) if it's possbile in HW-1162
      return;
    }

    parsedData = {
      raw: data,
      final: dataArrayToMap(parsedData),
    };

    updateTradePriceCacheFromTrade(parsedData.final);
  };

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.MarketData;

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataSubscribeTrade;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataUnsubscribeTrade;
}
